import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";
import { LogementService } from "../services/logement.service";
import { ToastService } from "../services/toast.service";

@Injectable({
  providedIn: 'root'
})
export class UpdatableGuard  {

  constructor(private logementService: LogementService,
              private router: Router,
              private toastService: ToastService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.logementService.logementCourant.pipe(map(logement => {
      if(!logement.userPermissions.updatable){
        if (isDevMode()) {
          console.warn("Vous n'avez pas de permission update sur ce logement.");
        }
        this.toastService.show('Accès refusé', {classname: 'toast-error'});
        this.router.navigate(['/accueil']);
      }
      return logement.userPermissions.updatable;
    }));
  }

}
